import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {ReceiptsPage} from './pages/ReceiptsPage';

export default function ReceiptsListPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/receipts" component={ReceiptsPage} />
            </Switch>
        </Suspense>
    );
}
